<div class="dialog-container">
  <header class="dialog-header">
    <div>
      <p class="dialog-eyebrow">{{ (isInquiry ? 'inquiry' : 'claim') | translate }}</p>
      <h2 class="dialog-title">{{ (isInquiry ? 'createAnInquiry' : 'createAClaim') | translate }}</h2>
    </div>

    <button
      type="button"
      class="close-btn"
      [mat-dialog-close]
      [attr.aria-label]="'cancel' | translate"
    >
      &times;
    </button>
  </header>

  <form
    class="claim-form"
    [formGroup]="claimForm"
    (ngSubmit)="onSubmit()"
    autocomplete="off"
  >
    <div class="dialog-content">
      <section class="form-section claim-details-section">
        <div class="section-heading-row">
          <h3>{{ (isInquiry ? 'inquiryDetails' : 'claimDetails') | translate }}</h3>

          <label class="confidential-row">
            <span>{{ "confidential" | translate }}</span>
            <span class="switch-control">
              <input
                type="checkbox"
                [checked]="isConfidential === 1"
                (change)="onConfidentialChange($event)"
              />
              <span class="switch-track" aria-hidden="true"></span>
            </span>
          </label>
        </div>

        <label
          class="form-field title-field"
          [class.has-error]="
            claimForm.get('title')?.invalid &&
            (claimForm.get('title')?.touched || isSubmitted)
          "
        >
          <span class="field-label">
            {{ "title" | translate }}
            <span class="required-marker" aria-hidden="true">*</span>
          </span>
          <input
            pInputText
            type="text"
            id="title"
            formControlName="title"
            required
            [attr.aria-required]="true"
          />
        </label>

        <div class="overview-grid">
          <div class="form-field dropdown-field">
            <span class="field-label">{{ "vesselName" | translate }}</span>
            <p-dropdown
              class="design-dropdown"
              [options]="vesselList"
              [filter]="true"
              filterBy="name,otherName"
              displayProperty="id"
              [(ngModel)]="selectedVessel"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="name"
              [placeholder]="'selectVessel' | translate"
              (onHide)="vesselTouched()"
              (onChange)="onVesselSelected()"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [showClear]="true"
              [style]="{ width: '100%' }"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span>{{ selectedVessel?.name || selectedVessel?.otherName }}</span>
              </ng-template>
              <ng-template pTemplate="item" let-vessel>
                <span>{{ vessel?.name || vessel?.otherName }}</span>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="form-field dropdown-field">
            <span class="field-label">{{ "equipProdName" | translate }}</span>
            <p-dropdown
              class="design-dropdown"
              [options]="vesselEquipList"
              [filter]="true"
              filterBy="name"
              displayProperty="id"
              [(ngModel)]="selectedVesselEquip"
              (onChange)="onVesselEquipSelected()"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="name"
              [placeholder]="
                (!selectedVessel ? 'selectVesselFirst' : 'selectEquip') | translate
              "
              (onHide)="equipTouched()"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [showClear]="true"
              [disabled]="!selectedVessel"
              [style]="{ width: '100%' }"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span>{{ selectedVesselEquip?.name }}</span>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="form-field readonly-field">
            <span class="field-label">{{ "shipyard" | translate }}</span>
            <strong>
              {{
                getCompanyName(selectedVessel?.builder_id) || "—"
              }}
            </strong>
          </div>

          <div class="form-field readonly-field">
            <span class="field-label">{{ "serialNo" | translate }}</span>
            <strong>{{ selectedVesselEquip?.serialNumber || "—" }}</strong>
          </div>

          <div class="form-field readonly-field">
            <span class="field-label">{{ "vesselNumber" | translate }}</span>
            <strong>{{ selectedVessel?.vesselNumber || "—" }}</strong>
          </div>

          <div class="form-field readonly-field">
            <span class="field-label">{{ "prodNameAndType" | translate }}</span>
            <strong>
              {{ updatedClaimProd?.name || "-" }} / 
              {{ updatedClaimProdCategory?.name || "-"  }}
            </strong>
          </div>
          <div class="form-field dropdown-field">
            <span class="field-label">{{ "assignedAgent" | translate }}</span>
            <p-dropdown
              class="design-dropdown"
              [options]="agentList"
              [filter]="true"
              filterBy="name,email"
              displayProperty="id"
              [(ngModel)]="selectedAssignee"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="displayLabel"
              [placeholder]="'selectAssignee' | translate"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [showClear]="true"
              [style]="{ width: '100%' }"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span>{{ selectedOption?.displayLabel }}</span>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="form-field dropdown-field">
            <span class="field-label">{{ "priority" | translate }}</span>
            <p-dropdown
              class="design-dropdown"
              [options]="priority"
              [filter]="false"
              displayProperty="id"
              [(ngModel)]="selectedPriority"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="name"
              placeholder="Select priority"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [style]="{ width: '100%' }"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span>{{ selectedOption?.name | translate }}</span>
              </ng-template>
              <ng-template pTemplate="item" let-priority>
                <span>{{ priority.name | translate }}</span>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="form-field dropdown-field">
            <span class="field-label">{{ "mark" | translate }}</span>
            <p-dropdown
              class="design-dropdown"
              [options]="mark"
              [filter]="false"
              displayProperty="id"
              [(ngModel)]="selectedMark"
              [ngModelOptions]="{ standalone: true }"
              optionLabel="name"
              placeholder="Select mark"
              [virtualScroll]="true"
              [virtualScrollItemSize]="38"
              [style]="{ width: '100%' }"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span>{{ selectedOption?.name | translate }}</span>
              </ng-template>
              <ng-template pTemplate="item" let-mark>
                <span>{{ mark.name | translate }}</span>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="form-field chips-field">
            <span class="field-label">{{ "tags" | translate }}</span>

            <div
              class="chips-autocomplete"
              (input)="onTagInput($event)"
              (mouseup)="onChipMouseUp($event)"
            >
              <p-chips
                #chipRef
                class="design-chips"
                [(ngModel)]="tags"
                [ngModelOptions]="{ standalone: true }"
                [allowDuplicate]="false"
                [caseSensitiveDuplication]="false"
                [addOnBlur]="true"
                separator=","
                [placeholder]="'enterTags' | translate"
                (onFocus)="openTagSuggestions($event)"
                (onAdd)="onTagAdded()"
                (onBlur)="closeTagSuggestions()"
              ></p-chips>

              <div
                *ngIf="showTagSuggestions && filteredTagOptions.length"
                class="tag-suggestions"
              >
                <button
                  *ngFor="let option of filteredTagOptions"
                  type="button"
                  class="tag-suggestion"
                  (mousedown)="selectTagSuggestion(option, $event)"
                >
                  {{ option }}
                </button>
              </div>
            </div>
          </div>
      
        </div>
        <div class="form-field cs-no-field"
          [class.has-error]="isSubmitted && csNumberInvalid"
        >
          <label class="field-label" for="csNumberDate">
            {{ "csNoDetail" | translate }}
          </label>

          <div class="cs-no-input">
            <span>CS</span>

            <input
              pInputText
              type="text"
              id="csNumberDate"
              [(ngModel)]="csNumberDate"
              [ngModelOptions]="{ standalone: true }"
              placeholder="YYMMDD"
              maxlength="6"
              inputmode="numeric"
              aria-label="CS number date"
            />

            <span>-</span>

            <input
              pInputText
              type="text"
              [(ngModel)]="csNumberSequence"
              [ngModelOptions]="{ standalone: true }"
              placeholder="1"
              inputmode="numeric"
              aria-label="CS number sequence"
            />
          </div>
        </div>
      </section>

      <section class="form-section incident-section">
        <h3>{{ "incidentDetails" | translate }}</h3>

        <div class="compact-grid">
          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "incidentTime" | translate }} (JST)</span>
            <input
              class="jst-datetime-input"
              type="datetime-local"
              matInput
              id="incidentDate"
              formControlName="incidentDate"
            />
          </label>

          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "incidentPlace" | translate }}</span>
            <input
              pInputText
              type="text"
              id="incidentPlace"
              formControlName="incidentPlace"
            />
          </label>
        </div>

        <label
          class="form-field textarea-field"
          [class.has-error]="
            claimForm.get('equipmentCurrentStatus')?.invalid &&
            (claimForm.get('equipmentCurrentStatus')?.touched || isSubmitted)
          "
        >
          <span class="field-label">
            {{ "currStatus" | translate }}
            <span class="required-marker" aria-hidden="true">*</span>
          </span>
          <textarea
            pInput
            id="equipmentCurrentStatus"
            formControlName="equipmentCurrentStatus"
            rows="4"
            required
            [attr.aria-required]="true"
          ></textarea>
        </label>

        <label class="form-field textarea-field">
          <span class="field-label">{{ "incidentLeadup" | translate }}</span>
          <textarea
            pInput
            id="incidentLeadup"
            formControlName="incidentLeadup"
            rows="4"
          ></textarea>
        </label>

        <label class="form-field textarea-field">
          <span class="field-label">{{ "measuresTaken" | translate }}</span>
          <textarea
            pInput
            id="responseMeasures"
            formControlName="responseMeasures"
            rows="4"
          ></textarea>
        </label>

        <label class="form-field textarea-field">
          <span class="field-label">{{ "detailsJRCS" | translate }}</span>
          <textarea
            pInput
            id="responseRequestDetails"
            formControlName="responseRequestDetails"
            rows="4"
          ></textarea>
        </label>

        <label class="form-field textarea-field">
          <span class="field-label">{{ "otherDetailsJRCS" | translate }}</span>
          <textarea
            pInput
            id="extraDetails"
            formControlName="extraDetails"
            rows="4"
          ></textarea>
        </label>
      </section>

      <section class="form-section contact-section">
        <h3>{{ "contactInfo" | translate }}</h3>

        <div class="compact-grid">
          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "companyContactName" | translate }}</span>
            <input
              pInputText
              type="text"
              id="contactPersonName"
              formControlName="contactPersonName"
            />
          </label>

          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "contactEmail" | translate }}</span>
            <input
              pInputText
              type="text"
              id="contactPersonEmail"
              formControlName="contactPersonEmail"
            />
          </label>

          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "contactPhone" | translate }}</span>
            <input
              pInputText
              type="text"
              id="contactPersonPhone"
              formControlName="contactPersonPhone"
            />
          </label>

          <label class="form-field input-field-wrap full-width-field">
            <span class="field-label">{{ "contactAddress" | translate }}</span>
            <input
              pInputText
              type="text"
              id="contactPersonAddress"
              formControlName="contactPersonAddress"
            />
          </label>

          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "nextPortDate" | translate }} (JST)</span>
            <input
              class="jst-datetime-input"
              type="datetime-local"
              matInput
              id="expectedPortCall"
              formControlName="expectedPortCall"
            />
          </label>

          <label class="form-field input-field-wrap">
            <span class="field-label">{{ "nextPortPlace" | translate }}</span>
            <input
              pInputText
              type="text"
              id="nextPort"
              formControlName="nextPort"
            />
          </label>
        </div>
      </section>

      <section class="form-section other-details-section">
        <h3>{{ "otherDetails" | translate }}</h3>

        <div class="other-details-grid">
          <div class="form-field readonly-field half-width">
            <span class="field-label">{{ "vesselType" | translate }}</span>
            <strong>{{ selectedVessel?.shipType || "—" }}</strong>
          </div>

          <div class="form-field readonly-field half-width">
            <span class="field-label">{{ "imo" | translate }}</span>
            <strong>{{ selectedVessel?.imo || "—" }}</strong>
          </div>

          <div class="form-field readonly-field half-width">
            <span class="field-label">{{ "owner" | translate }}</span>
            <strong>
              {{
                getCompanyName(selectedVessel?.owner_id) || "—"
              }}
            </strong>
          </div>

          <div class="form-field readonly-field half-width">
            <span class="field-label">{{ "manager" | translate }}</span>
            <strong>
              {{
                getCompanyName(selectedVessel?.manager_id) || "—"
              }}
            </strong>
          </div>

          <div class="form-field readonly-field third-width">
            <span class="field-label">
              {{ "shipDeliveryDate" | translate }}
            </span>
            <strong>{{ selectedVesselEquip?.shipDeliveryDate || "—" }}</strong>
          </div>

          <div class="form-field readonly-field third-width">
            <span class="field-label">
              {{ "retrofittingDate" | translate }}
            </span>
            <strong>{{ selectedVesselEquip?.retrofittingDate || "—" }}</strong>
          </div>

          <div class="form-field readonly-field third-width">
            <span class="field-label">{{ "warranty" | translate }}</span>
            <strong>
              {{ selectedVesselEquip?.warrantyExpirationDate || "—" }}
            </strong>
          </div>
        </div>
      </section>

      <section class="form-section attachments-section">
        <h3>{{ "attachments" | translate }}</h3>
        <div class="attachments-shell">
          <app-file-upload
            [selectedVessel]="selectedVessel"
            (fileListChange)="onFileListChange($event)"
          ></app-file-upload>
        </div>
      </section>
    </div>

    <footer class="dialog-footer">
      <button type="button" [mat-dialog-close] class="cancel-button">
        {{ "cancel" | translate }}
      </button>
      <button type="submit" class="save-button">
        {{ "save" | translate }}
      </button>
    </footer>
  </form>
</div>